import type { IModalActionResolver } from "@complex/Actions/Modal/logics/types";
import { add } from "date-fns";

export const formattedNextAction = (data: Pick<IModalActionResolver, "nextActionDate" | "nextActionStartTime">) => {
  if (!data.nextActionDate) {
    return;
  }
  const date = add(new Date(data.nextActionDate), { minutes: data.nextActionStartTime ?? 0 });
  return {
    nextActionDate: date,
  };
};
